export enum AllocationType {
  TotalPercent = 'Total Percent',
  LineItemDetails = 'Line Item Details',
  MonthlyPercentage = 'Monthly Percentage',
}
